import React, { ChangeEvent, useState } from 'react'
import { useStore } from 'effector-react'
import { $promoCode, setPromoCode, submitCreatePromoCode } from './model'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDatePicker,
  CForm,
  CFormInput,
  CRow,
} from '@coreui/react-pro'

const generateCode = () => {
  const list = 'ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789'
  var res = ''
  for (var i = 0; i < 6; i++) {
    var rnd = Math.floor(Math.random() * list.length)
    res = res + list.charAt(rnd)
  }
  return res
}

export const CreatePromoCode: React.FC = () => {
  const promoCode = useStore($promoCode)

  const [date, setDate] = useState('')
  const [validated, setValidated] = useState(false)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    value = event.currentTarget.value

    setPromoCode({
      ...promoCode,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreatePromoCode({
        ...promoCode,
        userId: Number(promoCode.userId),
        bonusPercent: Number(promoCode.bonusPercent),
        expiresAt: date,
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  return (
    <CCard>
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create promo code</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="code"
                value={promoCode.code}
                onChange={handleChange}
                label="Code"
                minLength={6}
                maxLength={10}
                required
              />
            </CCol>
            <CCol sm={4}>
              <CButton
                className="mt-4"
                type="button"
                onClick={() =>
                  setPromoCode({ ...promoCode, code: generateCode() })
                }
              >
                Generate code
              </CButton>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="number"
                name="bonusPercent"
                value={promoCode.bonusPercent}
                onChange={handleChange}
                label="Bonus % (value should be between 30 and 100)"
                min={30}
                max={100}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="userId"
                value={promoCode.userId}
                onChange={handleChange}
                label="User ID"
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CDatePicker
                date={promoCode.expiresAt}
                label="Expired at"
                locale="en-US"
                onDateChange={(date) => {
                  if (date) {
                    setDate(date.toISOString().replace('T', ' ').split('.')[0])
                  }
                }}
                required
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Create
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  )
}
